import { NAMESPACE } from "./_Namespace";
import { IRadObject, Property, RadObject, RadObjectPropertyValues } from "./RadObject";

export type AsyncIteratorPropertyValues =
    RadObjectPropertyValues
    & {
    };

export type AsyncIteratorProperties = {
    [name in keyof AsyncIteratorPropertyValues]: Property<AsyncIteratorPropertyValues[name]>
};

export interface IAsyncIterator extends IRadObject, AsyncIteratorProperties
{
}

export class AsyncIterator extends RadObject<AsyncIteratorPropertyValues> implements IAsyncIterator
{
    public static override classNamespace = NAMESPACE + "AsyncIterator";
    public static override className = "AsyncIterator";

    // #region Global Variables

    private _cancellationToken?: { isCancellationRequested: boolean };

    // #endregion

    // #region Public Methods

    public forEach(arr: any[], fn: Function)
    {
        if (this._cancellationToken)
            this._cancellationToken.isCancellationRequested = true;

        this._cancellationToken = { isCancellationRequested: false };

        return function (cancellationToken, arr, fn)
        {
            return (
                arr.reduce(
                    (promise, item) =>
                    {
                        return (
                            promise
                                .then((results: any) =>
                                {
                                    return new Promise((resolve, reject) =>
                                    {
                                        setTimeout(() =>
                                        {
                                            if (cancellationToken.isCancellationRequested)
                                                reject("Cancelled")

                                            resolve([...results, fn(item)]);
                                        });
                                    });
                                })
                        );
                    },
                    Promise.resolve([])
                )
            );
        }(this._cancellationToken, arr, fn);
    }

    // #endregion
}
